import { ParsedUrlQuery } from 'querystring';
import { IFacet } from '~/lib/data-contract';

export const toggleManyFacetQueries = (routerQuery: Record<string, ParsedUrlQuery[0]>, facets: IFacet[]) => {
	for (const facet of facets) {
		const enabled = facet.values.filter((item) => item.selected).map((item) => item.id);

		if (enabled.length === 0) {
			// No filters was set for current facet. Remove from query.
			delete routerQuery[facet.id];
			continue;
		}

		if (enabled.length === 1) {
			// One filter was defined for current facet. Set as string;
			routerQuery[facet.id] = enabled[0];
			continue;
		}

		// There was more than one filter enabled in the facet. Append as array.
		routerQuery[facet.id] = enabled;
	}
};
